var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar-navside"},[(_vm.viewIsMobile)?_c('MetaNavLoggedOut'):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"sidenav"},[_c('ThemeSwitcher'),_vm._v(" "),_c('Link',{staticClass:"testing-register-link",attrs:{"href":_vm.$url('joininfo'),"title":_vm.$i18n('register.topbar')}}),_vm._v(" "),_c('NavLogin')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }